import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import * as endpoints from "../../api/endpoints"
import { DateTime } from "luxon"
import * as date from "../../booking/helpers/date"
import { handleEvalTracking } from "../../helpers/tracking"
import { TransportOptions } from "../itinerary/PublicTransportationTypes"

export class ItineraryDepartureList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      flightInfo: props.flightInfo,
      airlinesPageLink: props.airlinesPageLink,
      departures: [],
      accordionOpen: false,
    }

    this.renderContentBlocks = this.props.renderContentBlocks.bind(this)
    this.showHideContent = this.props.showHideContent.bind(this)
  }

  async componentDidMount() {
    const dtLocale = date.luxonLocale(this.state.flightInfo.language)
    const zone = "Europe/Copenhagen"
    const estimatedPublicTime = DateTime.fromISO(this.state.flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)
    const ept = estimatedPublicTime.toJSDate().toISOString()
    const adjustedTime = estimatedPublicTime.plus({ minutes: this.props.block.departureBufferTime }).toJSDate().toISOString()

    const trainData = {
      id: this.props.block?.trainStationDepartureId || "8603328",
      datetime: adjustedTime,
      transportOptions: TransportOptions.allTrain,
      ept: ept,
      language: this.state.flightInfo.language,
    }
    const busData = {
      id: this.props.block?.busStationDepartureId || "000051935",
      datetime: adjustedTime,
      transportOptions: TransportOptions.allBus,
      ept: ept,
      language: this.state.flightInfo.language,
    }
    const metroData = {
      id: this.props.block?.metroStationDepartureId || "008600858",
      destId: this.state.block?.metroStationArrivalId || "8603307",
      datetime: adjustedTime,
      transportOptions: TransportOptions.metro,
      ept: ept,
      language: this.state.flightInfo.language,
    }

    let departuresLists = []
    departuresLists = await Promise.all([this.getDepatureBoard(trainData), this.getDepatureBoard(busData), this.getMetroTrip(metroData)])
      .then((responses) => {
        return Promise.all(
          responses.map((response) => {
            return response
          }),
        )
      })
      .then((data) => {
        return data
      })
      .catch((err) => {
        console.log(err)
      })
    const departures = [].concat.apply([], departuresLists)
    this.setState({ departures: departures })
  }

  getDepatureBoard(data) {
    return endpoints
      .getRejseplanenDepartureBoard(data)
      .then((res) => {
        return res.data
      })
      .then((data) => {
        let departures = []
        if (data) {
          departures = data
        }
        return departures
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getMetroTrip(data) {
    return endpoints
      .getRejseplanenTrip(data)
      .then((res) => {
        return res.data
      })
      .then((data) => {
        let departures = []
        if (data) {
          departures = data
        }
        return departures.slice(0, 2)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  handleAccordionClick = (e) => {
    this.showHideContent(e, ".contentWrapper")
    this.setState({ accordionOpen: !this.state.accordionOpen })
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    const theme = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    const hasContentBlocks = this.props.block.contentArea?.length > 0
    const newLink = this.state.airlinesPageLink + "/" + this.state.flightInfo.IataCode
    const hasDepartureLists = this.props.block.departureListContentArea?.length > 0

    const style = { "--itinerary-icon": `url(${this.props.block.itineraryIcon ? this.props.block.itineraryIcon : ""})` }

    return (
      <div
        style={this.props.block.itineraryIcon ? style : undefined}
        className={`departure-info__essentials__detailitems__detailitem ${theme ? theme : ""} foldable`}
      >
        <button
          className={"departure-info__essentials__detailitems__detailitem__header pointer"}
          aria-expanded={this.state.accordionOpen}
          aria-label={
            this.state.accordionOpen
              ? `${this.props.currentPageJson?.closeContentLabel || "Luk indhold for sektionen"} ${this.props.block.heading}`
              : `${this.props.currentPageJson?.openContentLabel || "Åben indhold for sektionen"} ${this.props.block.heading}`
          }
          onClick={(e) => this.handleAccordionClick(e)}
        >
          <h5>{this.props.block.heading || "Velkommen og på gensyn"}</h5>
          {this.props.block.subHeading ? <h6>{this.props.block.subHeading}</h6> : ""}
        </button>
        <div className={"contentWrapper show-hide hide-content"}>
          {this.props.block.text || this.props.block.buttonText ? (
            <div className={"textbuttoncontainer"}>
              {this.props.block.text ? <span className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></span> : ""}
              {this.props.block.buttonText && this.props.block.buttonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                      buttonColor ? buttonColor : "casc-blue"
                    }`}
                    href={this.props.block.linkToAirlineBool ? newLink : this.props.block.buttonLink}
                    onClick={() => handleEvalTracking(this.props.block.buttonTracking)}
                  >
                    {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                    <span className="text">{this.props.block.buttonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          {hasDepartureLists
            ? this.props.block.departureListContentArea.map((block, index) => {
                return <DepartureList key={index} {...this.state} {...block} block={block} parentBlock={this.props.block} />
              })
            : ""}
          {hasContentBlocks ? this.renderContentBlocks(this.state.block.contentArea, true, this.state.accordionOpen) : ""}
        </div>
      </div>
    )
  }
}

class DepartureList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      departures: props.departures,
      filteredDepartures: [],
    }
  }

  componentDidMount() {
    this.getFilteredDepartures()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.departures !== this.props.departures) {
      this.setState({ departures: this.props.departures }, () => {
        this.getFilteredDepartures()
      })
    }
  }

  getFilteredDepartures = () => {
    if (this.state.departures && this.state.departures.length > 0) {
      const exclusions = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.departureListTypeExclusions, true)
      if (exclusions && exclusions.length > 0) {
        let filteredDepartures = []
        filteredDepartures = this.state.departures.filter((d) => {
          if (d) {
            let include = true
            exclusions.forEach((ex) => {
              switch (ex.value) {
                case "Tog":
                  if ((d.Category & TransportOptions.allTrain) !== 0) {
                    include = false
                  }
                  break
                case "Bus":
                  if ((d.Category & TransportOptions.allBus) !== 0) {
                    include = false
                  }
                  break
                case "Metro":
                  if ((d.Category & TransportOptions.metro) !== 0) {
                    include = false
                  }
                  break
              }
            })
            return include
          }
          return false
        })
        this.setState({ filteredDepartures: filteredDepartures })
      } else {
        this.setState({ filteredDepartures: this.state.departures })
      }
    }
  }

  render() {
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)

    let departures = this.state.filteredDepartures
    if (this.props.block.maxDeparturesShown) {
      departures = departures.slice(0, this.props.block.maxDeparturesShown)
    }

    return (
      <div className="departure-info__essentials__detailitems__detailitem__infobox__departures">
        {this.props.block.text ? (
          <div
            className="departure-info__essentials__detailitems__detailitem__infobox__departures__desc"
            dangerouslySetInnerHTML={{ __html: this.props.block.text }}
          ></div>
        ) : (
          ""
        )}
        {departures.length > 2 ? (
          <div className="departure-info__essentials__detailitems__detailitem__infobox__departures__train">
            <ul>
              {departures.map((dep, index) => {
                if (dep) {
                  const timeUntil = dep.TimeUntil
                  return (
                    <li key={index}>
                      <span className="text--truncate">
                        ({dep.Name}) {this.props.parentBlock?.towardsLabel || "Mod"} {dep.FinalStop}
                      </span>
                      {dep.Cancelled ? (
                        <span className={`train-dep-min`}>
                          {this.props.parentBlock?.cancelledLabel || "(Aflyst)"} <span className={`strikethrough`}>{timeUntil}</span>
                        </span>
                      ) : (
                        <span className={`train-dep-min`}>{timeUntil}</span>
                      )}
                    </li>
                  )
                }
                return ""
              })}
            </ul>
          </div>
        ) : departures.length > 0 ? (
          departures.map((dep, index) => {
            if (dep) {
              const timeUntil = dep.TimeUntil
              return (
                <div key={index} className="departure-info__essentials__detailitems__detailitem__infobox__departures__metro">
                  <span className="text--truncate">
                    ({dep.Name}) {this.props.parentBlock?.towardsLabel || "Mod"} {dep.FinalStop}
                  </span>
                  {dep.Cancelled ? (
                    <span className={`train-dep-min`}>
                      {this.props.parentBlock?.cancelledLabel || "(Aflyst)"} <span className={`strikethrough`}>{timeUntil}</span>
                    </span>
                  ) : (
                    <span className={`train-dep-min`}>{timeUntil}</span>
                  )}
                </div>
              )
            }
            return ""
          })
        ) : (
          ""
        )}
        <div className="departure-info__essentials__detailitems__detailitem__infobox__departures__metro__desc">
          {this.props.block.ticketText ? this.props.block.ticketText : ""}
          {this.props.block.buttonText && this.props.block.buttonLink ? (
            <div className="cta-button">
              <a
                className={`button button--small button--general rm-this-class rm-this-class-hide-default ${buttonColor ? buttonColor : "casc-blue"}`}
                href={this.props.block.buttonLink}
              >
                <span className="text">{this.props.block.buttonText}</span>
              </a>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    )
  }
}
